module.exports = __webpack_public_path__ + "img/Cheer Megaphone38.f0a69ec1.jpg";